import { useSelector } from "react-redux"
import Squiggles from "@/assets/svg/squiggles.svg"
import Waves from "@/assets/svg/waves.svg"
import ColorBokeh from "@/components/ColorBokeh"
import { selectIsUserLoggedIn } from "@/redux/features/activeUserSlice"
import * as styles from "@/styles/modules/Section.module.scss"

const shapes = {
  squiggles: Squiggles,
  waves: Waves,
}

interface SectionProps {
  anchorId?: string
  children?: React.ReactNode
  className?: string
  first?: boolean
  backgroundColor?: "background" | "altBackground" | "primaryGradientDark3"
  shape?: "squiggles" | "waves"
  shapePosition?: "bottom" | "top"
  shapeColor?: "background" | "altBackground"
  style?: React.CSSProperties
  colorBokeh?: boolean
}

const Section = ({
  anchorId,
  children,
  className,
  first = false,
  backgroundColor,
  shape,
  shapePosition = "bottom",
  shapeColor = "background",
  style,
  colorBokeh,
}: SectionProps) => {
  const isLoggedIn = useSelector(selectIsUserLoggedIn)
  const Shape = shape ? shapes[shape] : undefined
  const shapeColors = {
    background: "var(--background)",
    altBackground: "var(--alt-background)",
  }

  const positionStyles = {
    bottom: { bottom: "-1px", transform: "translateX(-50%)" },
    top: { top: "-1px", transform: "scale(-1) translateX(50%)" },
  }

  const baseWrapperStyles = `${styles.wrapper} ${shape ? styles[shape] : ""} ${
    shape && shapePosition ? styles[shapePosition] : ""
  } ${first ? styles.first : ""} ${
    first && !isLoggedIn ? styles.firstExtraPadding : ""
  }`

  return (
    <section
      id={anchorId}
      className={
        className ? `${baseWrapperStyles} ${className}` : baseWrapperStyles
      }
      data-background={backgroundColor}
      style={style}
    >
      {colorBokeh && <ColorBokeh />}
      {children}
      {shape && (
        <Shape
          className={styles.shape}
          style={{
            fill: shapeColors[shapeColor],
            ...positionStyles[shapePosition],
          }}
        />
      )}
    </section>
  )
}

Section.displayName = "Section"

export default Section
